import apiClient from '../apiClient';

const auditLogService = {
  getAuditLogs: async (params = {}) => {
    const response = await apiClient.get('audit-logs', { params });
    return response.data || response;
  },

  getAuditLogById: async (id) => {
    const response = await apiClient.get(`audit-logs/${id}`);
    return response.data || response;
  },

  getAuditStats: async (period = 'month') => {
    const response = await apiClient.get('audit-logs/stats', { params: { period } });
    return response.data || response;
  }
};

export { auditLogService };
export default auditLogService;
